import * as React from 'react';

import { createIllustration } from './Illustration';

function describeWithOptions(name: string, description: string) {
  return {
    name,
    description,
    height: 80,
    width: 80,
  };
}

// ------------------------------
// Appreciate
// ------------------------------

export const SpotAppreciate = createIllustration(
  describeWithOptions(
    'SpotAppreciate',
    'Illustration of a thumbs up with a sparkling star above it.'
  ),
  <React.Fragment>
    <circle cx={40} cy={44.941} fill="#F2F3F4" r={34.4} />
    <path
      d="M50.088 77.684l-6.467-4.13c-6.798-2.19-15.464-5.052-18.745-7.134-3.28-2.082-2.059-6.192-2.059-6.192-1.892-3.572.117-7.082.117-7.082-.885-5.224 3.719-8.704 3.719-8.704-.665-1.57 1.307-5.838 3.922-6.384 1.462-.304 4.112 1.266 6.726 2.814 2.064 1.223 4.107 2.433 5.525 2.697 1.972.368 3.063-2.617 4.168-5.64.696-1.907 1.399-3.83 2.332-4.938 2.412-2.866 10.51-5.444 5.76.7-3.562 4.602-3.675 8.952-3.77 12.61-.032 1.223-.062 2.37-.218 3.422-.624 4.196-1.621 7.94-1.621 7.94l17.625 8.269a35.264 35.264 0 01-17.014 11.752z"
      fill="#FCBDA4"
    />
    <path
      d="M41.973 47.318c.08-.297-.074-.608-.343-.696-.27-.087-.553.082-.632.378-.2.747-.899 1.178-1.744 1.405a5.92 5.92 0 01-1.432.195h-.037l-10.948-4.68-.369 1.043 10.984 4.695.038.03a3.93 3.93 0 01.84.938c.404.639.705 1.548.326 2.73-.31.962-1.126 1.423-2.002 1.63a5.489 5.489 0 01-1.597.127l-.012-.001-12.015-2.516-.19 1.099L34.804 56.2l.017.01.017.012a5.112 5.112 0 011.105 1.033c.553.705.956 1.648.606 2.813-.42 1.398-1.436 1.907-2.448 2.062a5.36 5.36 0 01-1.351.022 5.434 5.434 0 01-.538-.084l-.018-.005-.008-.001-.006-.002-9.247-2.378-.232 1.09 9.233 2.374.013.005.1.039a5.264 5.264 0 011.401.846c.35.306.64.67.792 1.09.147.404.183.903-.034 1.534-.208.604-.52.943-.855 1.139-.348.203-.758.274-1.178.263a4.621 4.621 0 01-1.56-.356l-.021-.01-.004-.001c-.259-.121-.557.01-.667.294-.11.285.01.613.268.735l.2-.515-.2.515h.002l.003.002.01.005a2.281 2.281 0 00.155.065c.102.041.246.095.423.149.35.108.836.222 1.366.236.529.014 1.13-.072 1.68-.394.563-.329 1.037-.884 1.329-1.731.303-.88.273-1.67.027-2.346-.222-.611-.606-1.094-1.006-1.463l.063-.009c1.219-.187 2.684-.858 3.273-2.818.504-1.678-.117-3.023-.802-3.896a5.772 5.772 0 00-.303-.356c.148-.023.302-.052.459-.09 1.002-.236 2.26-.838 2.746-2.35.515-1.603.092-2.886-.45-3.743a4.867 4.867 0 00-.257-.366c.187-.032.386-.073.589-.128.912-.246 2.112-.815 2.477-2.174z"
      fill="#F49E7C"
    />
    <path
      clipRule="evenodd"
      d="M50.598.513l1.274 3.318-1.473.574-1.274-3.317 1.473-.575zm-7.687 5.568l3.38 1.905-.751 1.413-3.38-1.905.751-1.413zm-1.198 9.617l3.42-.59.283 1.594-3.418.59-.285-1.594z"
      fill="#CBC1F4"
      fillRule="evenodd"
    />
    <path
      d="M48.804 9.863a.714.714 0 01.762-1.037l3.697.647a.726.726 0 00.642-.203l2.611-2.638a.732.732 0 011.24.406l.55 3.67a.727.727 0 00.399.542l3.365 1.659a.714.714 0 01.004 1.287l-3.356 1.62a.71.71 0 00-.396.539l-.526 3.664c-.085.589-.816.82-1.238.391l-2.624-2.667a.737.737 0 00-.644-.21l-3.691.607c-.593.097-1.047-.52-.77-1.046l1.732-3.273a.71.71 0 00-.002-.668l-1.755-3.29z"
      fill="#FC1C88"
    />
  </React.Fragment>
);

// ------------------------------
// Attention
// ------------------------------

export const SpotAttention = createIllustration(
  describeWithOptions(
    'SpotAttention',
    'Illustration of a hand pointing towards a sparkling star.'
  ),
  <React.Fragment>
    <path
      d="M75.323 42.586c0 18.998-15.759 34.4-35.2 34.4-19.44 0-35.2-15.402-35.2-34.4 0-18.999 15.76-34.4 35.2-34.4 19.441 0 35.2 15.401 35.2 34.4z"
      fill="#F2F3F4"
    />
    <path
      d="M12.665 14.659a.727.727 0 01.347-1.257l3.685-.716a.73.73 0 00.529-.422l1.511-3.44a.727.727 0 011.303-.061l1.808 3.28a.726.726 0 00.565.371l3.732.362c.6.058.87.778.459 1.219l-2.567 2.742a.728.728 0 00-.18.653l.801 3.662a.729.729 0 01-1.02.815l-3.394-1.584a.728.728 0 00-.677.032l-3.237 1.902a.725.725 0 01-1.089-.714l.465-3.725a.724.724 0 00-.238-.632l-2.803-2.487z"
      fill="#FC1C88"
    />
    <path
      clipRule="evenodd"
      d="M14.455 3.036l.762 3.47-1.542.348-.762-3.47 1.542-.348zm-7.95 6.071l3.331 1.988-.786 1.393-3.33-1.987.785-1.394zm-1.08 9.554l3.438-.468.227 1.604-3.437.468-.228-1.604z"
      fill="#CBC1F4"
      fillRule="evenodd"
    />
    <path
      d="M42.09 76.933a522.36 522.36 0 01-3.422-8.943l-.06-.047c-1.602-1.251-4.175-3.262-5.797-5.135-3.31-3.809-4.789-9.242-5.243-11.236a2.21 2.21 0 01.192-1.48L30 45.6l3.813-6.66c.146-.048-1.438-3.336-3.159-6.908-1.101-2.286-2.258-4.688-3.054-6.432-.38-.827-.448-1.786.576-2.493 1.024-.707 2.28-.194 2.624.493l14.017 19.035s.667 1.024 1.771 1.916c.932-.931 1.429-2.962 1.93-5.013.434-1.773.871-3.56 1.596-4.664 1.875-2.857 8.878-6.238 5.232-.178-2.731 4.545-2.395 8.394-2.113 11.63.094 1.082.183 2.096.148 3.045a71.487 71.487 0 01-.662 7.213l-.926 4.359 6.502 11.11a35.581 35.581 0 01-16.206 4.88z"
      fill="#FCBDA4"
    />
    <path
      d="M34.577 39.835a.6.6 0 10-1.154.33c.405 1.417.82 2.668 1.602 4.076.78 1.404 1.912 2.941 3.729 4.96a.6.6 0 00.892-.802c-1.783-1.982-2.851-3.444-3.572-4.74-.717-1.292-1.102-2.441-1.497-3.824zm-3.135 3.586a.6.6 0 01.737.421c.592 2.17 1.174 3.613 1.886 4.8.711 1.185 1.57 2.144 2.76 3.334a.6.6 0 11-.85.848c-1.21-1.21-2.151-2.251-2.94-3.565-.788-1.314-1.406-2.871-2.014-5.101a.6.6 0 01.421-.737zm-2.007 4.002a.6.6 0 01.742.412c.787 2.755 1.557 4.668 3.484 6.98a.6.6 0 11-.922.769c-2.073-2.487-2.903-4.574-3.716-7.42a.6.6 0 01.412-.741z"
      fill="#F49E7C"
    />
  </React.Fragment>
);

// ------------------------------
// Caution
// ------------------------------

export const SpotCaution = createIllustration(
  describeWithOptions(
    'SpotCaution',
    'Illustration of an exlamation point within a triangle, symbolising caution.'
  ),
  <React.Fragment>
    <circle cx={40.5} cy={40.5} fill="#F2F3F4" opacity={0.69} r={34.5} />
    <path
      d="M38.143 17.908c1.157-2.01 4.049-2.01 5.206 0l22.99 39.967c1.157 2.011-.29 4.525-2.603 4.525h-45.98c-2.314 0-3.76-2.514-2.603-4.525l22.99-39.967z"
      fill="#CBC1F4"
    />
    <path
      clipRule="evenodd"
      d="M54.648 37.552l11.69 20.323c1.158 2.011-.288 4.525-2.602 4.525h-45.98c-2.314 0-3.76-2.514-2.603-4.525l.278-.483c4.106-4.64 10.73-9.24 20.269-9.992 7.293-.576 13.458-4.628 18.948-9.848z"
      fill="#fff"
      fillOpacity={0.12}
      fillRule="evenodd"
    />
    <rect
      fill="#fff"
      height={22.941}
      rx={1.912}
      width={3.824}
      x={38.788}
      y={26.782}
    />
    <circle cx={40.7} cy={54.503} fill="#fff" r={1.912} />
    <path
      clipRule="evenodd"
      d="M63.904 29.25a.72.72 0 01-.553.854l-4.005.858 2.825 2.018-7.63 1.526a.72.72 0 01-.282-1.412l4.37-.874-2.775-1.982 7.195-1.542a.72.72 0 01.855.553zM53.11 13.677a.72.72 0 01.143 1.008l-2.46 3.275 3.456-.33-4.757 6.157a.72.72 0 01-1.14-.88l2.726-3.527-3.395.325 4.419-5.884a.72.72 0 011.008-.144zM26.304 33.95a.72.72 0 00-.553-.854l-4.005-.858 2.825-2.018-7.63-1.526a.72.72 0 00-.282 1.412l4.37.874-2.775 1.982 7.195 1.542a.72.72 0 00.855-.553zm5.206-10.027a.72.72 0 00.143-1.008l-2.46-3.275 3.456.33-4.757-6.157a.72.72 0 00-1.14.88l2.726 3.527-3.395-.325 4.419 5.884a.72.72 0 001.008.144z"
      fill="#CBC1F4"
      fillRule="evenodd"
    />
  </React.Fragment>
);

// ------------------------------
// Celebrate
// ------------------------------

export const SpotCelebrate = createIllustration(
  describeWithOptions(
    'SpotCelebrate',
    'Illustration of a party popper being set off and confetti streaming from it.'
  ),
  <React.Fragment>
    <ellipse cx={37.477} cy={41.786} fill="#F2F3F4" rx={35.2} ry={34.4} />
    <path
      d="M11.083 69.11c-1.345.49-2.607-.898-1.992-2.19l19.684-41.368 25.84 27.724L11.083 69.11z"
      fill="#DED8F8"
    />
    <ellipse
      cx={42.782}
      cy={38.401}
      fill="#D0C7F5"
      rx={19.321}
      ry={7.431}
      transform="rotate(-132.986 42.782 38.4)"
    />
    <path
      clipRule="evenodd"
      d="M53.509 18.217a.8.8 0 01.118 1.125c-.618.762-1.47.965-2.261.957-.745-.007-1.554-.201-2.253-.369a10.366 10.366 0 00-.047-.011c-.758-.182-1.396-.331-1.938-.337-.512-.005-.798.12-.993.362-.194.241-.254.547-.139 1.048.122.53.406 1.122.747 1.824l.021.044c.315.647.678 1.396.845 2.121.178.77.163 1.647-.45 2.412-.615.765-1.467.968-2.258.96-.744-.007-1.553-.2-2.253-.369l-.047-.011c-.76-.182-1.4-.332-1.944-.337-.514-.005-.801.12-.996.361-.195.242-.255.548-.14 1.048.123.53.406 1.123.748 1.826l.022.045c.315.647.679 1.396.847 2.12.178.771.164 1.648-.45 2.413a.8.8 0 01-1.248-1.001c.195-.243.255-.55.139-1.051-.123-.53-.407-1.124-.749-1.827l-.021-.044c-.315-.647-.68-1.396-.846-2.121-.178-.77-.164-1.648.452-2.412.615-.763 1.468-.965 2.259-.957.743.007 1.552.201 2.25.37l.05.011c.76.182 1.4.331 1.942.336.514.005.8-.12.995-.362.195-.243.255-.55.14-1.05-.123-.53-.406-1.123-.747-1.826a9.794 9.794 0 01-.022-.045c-.314-.647-.678-1.394-.845-2.119-.177-.77-.163-1.646.451-2.41.614-.764 1.466-.966 2.255-.959.742.008 1.55.201 2.246.369l.05.012c.76.182 1.398.331 1.942.336.514.005.804-.12 1.002-.364a.8.8 0 011.126-.118zM77.995 31.73a.8.8 0 01-.55.99c-.942.269-1.756-.054-2.4-.514-.606-.434-1.157-1.057-1.633-1.595l-.032-.036c-.516-.585-.953-1.073-1.394-1.389-.417-.298-.722-.36-1.02-.273-.298.086-.523.302-.716.778-.204.504-.312 1.152-.435 1.923l-.008.049c-.114.71-.246 1.531-.525 2.221-.297.733-.812 1.442-1.754 1.716-.941.274-1.756-.049-2.4-.509-.605-.432-1.156-1.056-1.633-1.595a6.008 6.008 0 00-.032-.036c-.517-.586-.956-1.075-1.398-1.392-.418-.3-.725-.362-1.023-.276-.298.086-.523.302-.716.778-.204.504-.312 1.153-.435 1.925l-.008.05c-.114.71-.245 1.532-.524 2.222-.297.733-.811 1.443-1.754 1.717a.8.8 0 01-.446-1.536c.298-.087.523-.304.716-.781.204-.505.312-1.154.436-1.925l.008-.05c.113-.71.245-1.532.524-2.222.297-.733.812-1.443 1.754-1.715s1.757.052 2.4.512c.604.433 1.155 1.056 1.63 1.594l.035.039c.517.585.955 1.074 1.397 1.39.418.298.724.36 1.023.274.299-.087.524-.304.717-.78.204-.505.312-1.153.436-1.924l.008-.05c.114-.71.245-1.53.524-2.22.297-.732.811-1.44 1.753-1.714.941-.273 1.755.05 2.397.51.603.43 1.153 1.053 1.628 1.59l.034.039c.516.584.954 1.073 1.397 1.39.418.298.727.363 1.03.276a.8.8 0 01.989.55z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      d="M39.164 4.403l3.48.48c.16.023.311.088.44.192a.949.949 0 01.15 1.322L39.76 10.69a.871.871 0 01-.993.262.927.927 0 01-.43-.346.96.96 0 01-.164-.534l-.004-4.775a.928.928 0 01.298-.682.859.859 0 01.698-.212zm29.661 39.812l-.844 3.41a.898.898 0 01-.236.417.95.95 0 01-1.331.011l-3.904-3.908a.872.872 0 01-.156-1.015.928.928 0 01.39-.391.96.96 0 01.548-.107l4.749.498a.93.93 0 01.647.369.857.857 0 01.137.716zM63.753 22.4a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zm-8.8 8a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2zm-26.4-11.2a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z"
      fill="#CBC1F4"
    />
  </React.Fragment>
);

// ------------------------------
// NoResults
// ------------------------------

export const SpotNoResults = createIllustration(
  describeWithOptions(
    'SpotNoResults',
    'Illustration of a hand holding a magnifying glass. Within the lens of the magnifying glass is a question mark.'
  ),
  <React.Fragment>
    <circle
      cx={41.645}
      cy={45.675}
      fill="#F2F3F4"
      r={34.4}
      transform="rotate(-75 41.645 45.675)"
    />
    <path d="M33.116 46.142l8.66-5 12 20.785-8.66 5z" fill="#CBC1F4" />
    <path
      d="M64.85 70.747l-3.226.322c-6.13 2.292-13.982 5.163-17.526 5.526-3.544.363-5.016-3.312-5.016-3.312-3.4-1.51-3.966-5.2-3.966-5.2-3.622-3.28-2.31-8.43-2.31-8.43-1.172-1.51-1.263-4.5-.388-5.555.874-1.055 2.499-2.303 5.888-2.772 1.698-.235 3.802-.972 5.162-1.5.76-.297 1.375-.871 1.979-1.436.115-.108.23-.215.345-.32.958-.872 2.747-1.803 5.768-1.145 2.359.514 4.718 1.657 6.375 2.59 1.532.861 3.2 1.492 4.949 1.648l12.674 1.126A34.251 34.251 0 0164.85 70.746z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M47.638 46.526c1.09-.206 2.26-.112 3.013.034a.5.5 0 01-.191.981c-.667-.13-1.706-.208-2.636-.033-.943.178-1.63.582-1.87 1.293-.164.488-.169 1.31-.036 2.349.13 1.015.378 2.158.656 3.238a53.489 53.489 0 001.18 3.933l.021.062.006.015.005.014.002.008.002.005.004.015.02.062.08.238c.07.206.174.501.308.852.269.705.654 1.63 1.126 2.524.475.902 1.021 1.738 1.6 2.293.583.56 1.1.744 1.572.607.544-.158.872-.613.983-1.48.111-.877-.027-2.043-.316-3.344-.441-1.98-1.198-4.137-1.8-5.851a99.182 99.182 0 01-.503-1.458.5.5 0 01.949-.316c.134.404.3.877.483 1.398.603 1.72 1.392 3.965 1.847 6.01.296 1.33.466 2.634.332 3.687-.136 1.062-.608 1.998-1.696 2.314-.98.285-1.856-.185-2.544-.845-.693-.665-1.298-1.613-1.792-2.548a24.394 24.394 0 01-1.175-2.635 26.89 26.89 0 01-.405-1.137l-.021-.068-.006-.016-.005-.014-.022-.065-.084-.246a54.516 54.516 0 01-1.12-3.765c-.282-1.1-.542-2.288-.679-3.36-.134-1.05-.163-2.074.081-2.796.414-1.224 1.555-1.752 2.631-1.955z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M34.524 59.653a.499.499 0 01.322-.629l11.155-3.58a.499.499 0 11.308.951l-11.155 3.58a.501.501 0 01-.63-.322zm3.019 7.55a.5.5 0 01.254-.66l10.593-4.717a.5.5 0 11.406.914l-10.593 4.717a.5.5 0 01-.66-.254zm13.37.73c.894-.428 1.922-.643 2.862-.506.958.14 1.83.652 2.313 1.658.568 1.182.457 2.185-.032 2.976-.466.754-1.24 1.256-1.896 1.57a.499.499 0 11-.433-.901c.583-.28 1.157-.677 1.477-1.195.297-.48.413-1.12-.019-2.02-.316-.658-.872-1-1.554-1.1-.698-.102-1.522.056-2.28.417l-8.124 4.114a.501.501 0 01-.454-.891l8.14-4.122z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M52.324 67.238a3.936 3.936 0 01-.825 1.483l-.739-.675c.227-.248.473-.65.605-1.094.132-.444.135-.873-.033-1.224l.902-.431c.311.648.266 1.35.09 1.94z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <circle
      cx={29.32}
      cy={28.914}
      fill="#CBC1F4"
      r={21}
      transform="rotate(-30 29.32 28.914)"
    />
    <path
      clipRule="evenodd"
      d="M43.84 19.063a.6.6 0 01.83.176c5.594 8.616 3.145 20.135-5.47 25.73a.6.6 0 01-.654-1.007c8.06-5.233 10.35-16.01 5.117-24.07a.6.6 0 01.176-.83z"
      fill="#F8F8F9"
      fillOpacity={0.6}
      fillRule="evenodd"
    />
    <circle
      cx={28.852}
      cy={28.789}
      fill="#F2F3F4"
      opacity={0.5}
      r={15}
      transform="rotate(-30 28.852 28.789)"
    />
    <path
      d="M43.49 25.5L18.966 40.075a14.98 14.98 0 01-3.104-3.786 14.932 14.932 0 01-2.008-7.136L36.342 15.79a14.931 14.931 0 015.5 5.499 14.997 14.997 0 011.649 4.21zM24.095 43.015a15.02 15.02 0 01-3.753-1.87L43.79 27.378a15.01 15.01 0 01-.197 4.189L24.096 43.015z"
      fill="#CBC1F4"
      fillOpacity={0.3}
      opacity={0.5}
    />
    <path
      d="M28.83 31.248c.69-.102.943-.595.896-1.283-.1-1.05.181-1.645 1.433-2.654 1.28-1.046 1.943-2.295 1.7-3.942-.346-2.349-2.509-3.692-5.283-3.283-2.125.313-3.609 1.443-4.041 3.006-.13.442-.172.828-.104 1.285.095.648.525.987 1.184.89.531-.078.827-.36.942-1.05.17-1.21.926-1.972 2.212-2.162 1.413-.208 2.507.51 2.692 1.765.153 1.041-.21 1.746-1.382 2.711-1.26 1.033-1.785 2.033-1.585 3.393l.036.245c.104.701.555 1.189 1.3 1.079zm.664 4.517c.797-.118 1.316-.802 1.201-1.578-.114-.776-.807-1.282-1.604-1.164-.776.114-1.305.8-1.19 1.576.114.776.817 1.28 1.593 1.166z"
      fill="#FC1C88"
    />
  </React.Fragment>
);

// ------------------------------
// Wave
// ------------------------------

export const SpotWave = createIllustration(
  describeWithOptions(
    'SpotWave',
    'Illustration of a hand waving with a sparkling star above it.'
  ),
  <React.Fragment>
    <ellipse cx={40.123} cy={42.586} fill="#F2F3F4" rx={35.2} ry={34.4} />
    <path
      d="M56.936 73.262l-6.343-6.672-.752-.154c-1.78-.362-3.65-.743-5.865-1.69-3.71-1.577-6.14-3.271-8.52-4.93C34 58.8 32.56 57.797 30.858 56.843c-5.772-3.237-8.363-4.83-10.824-6.494-.718-.485-1-1.364-.656-2.33.343-.968 1.75-1.22 2.474-.869l10.914 4.834.228-.786-14.606-8.73c-.724-.5-1.538-1.61-.883-2.757.655-1.148 2.24-1.288 2.956-.834l15.668 8.48.354-.623c.196-.2-11.593-9.302-16.075-12.622-.732-.537-1.127-1.745-.473-2.818.674-1.107 2.368-1.242 3.046-.808L40.07 42.349l.24-.565c.194-.188-8.597-8.984-12.482-12.247-.72-.603-1.24-1.818-.571-2.94.668-1.121 2.424-.737 3.05-.25l16.287 13.699s1.081.654 2.518.978c.48-1.319.067-3.47-.35-5.643-.361-1.879-.725-3.773-.517-5.157.537-3.58 5.717-10.066 4.894-2.627-.615 5.576 1.381 9.054 3.059 11.977.561.98 1.087 1.896 1.468 2.809a73.804 73.804 0 012.514 7.125l1.142 5.1 8.313 6.149a35.785 35.785 0 01-12.698 12.505z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M50.442 58.044c-6.216-6.266-4.275-14.024-2.772-17.48l1.097.492c-1.434 3.298-3.158 10.401 2.52 16.125a.615.615 0 01.003.86.594.594 0 01-.848.003z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      d="M12.665 14.659a.727.727 0 01.347-1.257l3.685-.716a.73.73 0 00.529-.422l1.511-3.44a.727.727 0 011.303-.061l1.808 3.28a.726.726 0 00.565.371l3.732.362c.6.058.87.778.459 1.219l-2.567 2.742a.728.728 0 00-.18.653l.801 3.662a.729.729 0 01-1.02.815l-3.394-1.584a.727.727 0 00-.677.032l-3.237 1.902a.725.725 0 01-1.089-.714l.465-3.725a.725.725 0 00-.238-.632l-2.803-2.487z"
      fill="#FC1C88"
    />
    <path
      clipRule="evenodd"
      d="M14.454 3.036l.763 3.47-1.542.348-.762-3.47 1.541-.348zM6.505 9.107l3.331 1.988-.786 1.393-3.33-1.987.785-1.394zm-1.08 9.554l3.438-.468.227 1.604-3.437.468-.228-1.604z"
      fill="#CBC1F4"
      fillRule="evenodd"
    />
  </React.Fragment>
);
